export const getPerfomanceNowTimeSec = (): number => performance.now() / 1000;
